(function () {
  'use strict';

  /* ---------------------------------------------------------------
     Barra de anúncio rotativa
     --------------------------------------------------------------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('[data-announcement-msg]');
    if (msgs.length < 2) return;
    var interval = parseInt(bar.dataset.interval, 10) || 4200;
    var i = 0;
    setInterval(function () {
      msgs[i].hidden = true;
      msgs[i].classList.remove('fade-up');
      i = (i + 1) % msgs.length;
      msgs[i].hidden = false;
      void msgs[i].offsetWidth;
      msgs[i].classList.add('fade-up');
    }, interval);
  });

  /* ---------------------------------------------------------------
     Menu mobile
     --------------------------------------------------------------- */
  var nav = document.getElementById('mobile-nav');
  var navOpen = document.getElementById('nav-open');
  var navClose = document.getElementById('nav-close');

  function setNav(open) {
    if (!nav) return;
    nav.dataset.open = open ? 'true' : 'false';
    nav.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (navOpen) navOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  if (navOpen) navOpen.addEventListener('click', function () { setNav(true); });
  if (navClose) navClose.addEventListener('click', function () { setNav(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setNav(false);
  });

  /* ---------------------------------------------------------------
     Hero: carrossel com setas, teclado, swipe e autoplay
     --------------------------------------------------------------- */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    if (slides.length < 2) return;

    var dots = hero.querySelectorAll('[data-hero-dot]');
    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');
    var delay = parseInt(hero.dataset.autoplay, 10) || 0;
    var index = 0;
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === index); });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === index);
        d.setAttribute('aria-selected', k === index ? 'true' : 'false');
      });
    }

    function start() {
      if (!delay || reduced) return;
      stop();
      timer = setInterval(function () { show(index + 1); }, delay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); start(); });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { show(k); start(); });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);

    hero.setAttribute('tabindex', '0');
    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });

    // Swipe
    var startX = null, startY = null, dx = 0, swiping = false;
    hero.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY; dx = 0; swiping = false;
      stop();
    }, { passive: true });

    hero.addEventListener('touchmove', function (e) {
      if (startX === null) return;
      var t = e.touches[0];
      var mx = t.clientX - startX;
      var my = t.clientY - startY;
      if (!swiping && Math.abs(mx) > Math.abs(my) && Math.abs(mx) > 8) swiping = true;
      dx = mx;
    }, { passive: true });

    hero.addEventListener('touchend', function () {
      if (swiping && Math.abs(dx) > 40) show(dx < 0 ? index + 1 : index - 1);
      startX = null; startY = null; dx = 0; swiping = false;
      start();
    });

    show(0);
    start();
  });

  /* ---------------------------------------------------------------
     Carrosséis horizontais de produto
     --------------------------------------------------------------- */
  document.querySelectorAll('[data-hscroll]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-hscroll-track]');
    var prev = wrap.querySelector('[data-hscroll-prev]');
    var next = wrap.querySelector('[data-hscroll-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector(':scope > *');
      return card ? card.getBoundingClientRect().width + 16 : 260;
    }
    function update() {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    update();
  });

  /* ---------------------------------------------------------------
     Seletor interativo de categoria (home)
     --------------------------------------------------------------- */
  document.querySelectorAll('[data-showcase]').forEach(function (box) {
    var tabs = box.querySelectorAll('[data-showcase-tab]');
    var panels = box.querySelectorAll('[data-showcase-panel]');

    tabs.forEach(function (tab, k) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) {
          t.classList.toggle('is-active', j === k);
          t.setAttribute('aria-selected', j === k ? 'true' : 'false');
        });
        panels.forEach(function (p, j) { p.hidden = j !== k; });
      });
    });
  });

  /* ---------------------------------------------------------------
     Coleção: filtros e ordenação
     --------------------------------------------------------------- */
  var filterForm = document.getElementById('col-filter-form');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      // o slider de preço tem submit próprio, para não enviar a cada pixel
      if (e.target && e.target.hasAttribute('data-col-price-slider')) return;
      filterForm.submit();
    });
  }

  var sortSelect = document.getElementById('col-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  var sideOpen = document.getElementById('col-side-open');
  var sideClose = document.getElementById('col-side-close');
  var side = document.getElementById('col-side');
  if (sideOpen && side) sideOpen.addEventListener('click', function () { side.classList.add('is-open'); });
  if (sideClose && side) sideClose.addEventListener('click', function () { side.classList.remove('is-open'); });

  /* ---------------------------------------------------------------
     Revelar ao rolar
     --------------------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();

/* =================================================================
   Página de produto
   ================================================================= */
(function () {
  'use strict';

  /* Galeria: miniatura troca o slide */
  var thumbs = document.querySelectorAll('[data-pdp-thumb]');
  var slides = document.querySelectorAll('[data-pdp-slide]');

  function pdpShowSlide(i) {
    i = String(i);
    var achou = false;
    slides.forEach(function (s) {
      var on = s.dataset.pdpSlide === i;
      s.classList.toggle('is-active', on);
      if (on) achou = true;
    });
    if (!achou) return;
    thumbs.forEach(function (x) { x.classList.toggle('is-active', x.dataset.pdpThumb === i); });
    var alvo = document.querySelector('[data-pdp-thumb="' + i + '"]');
    if (alvo && alvo.scrollIntoView) {
      alvo.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { pdpShowSlide(t.dataset.pdpThumb); });
  });

  /* Os slides ficam em display:none, entao imagem lazy so baixa na hora do
     clique. Depois que a pagina termina de abrir, puxa o resto em segundo
     plano para a troca de foto ser instantanea. */
  function pdpWarmGallery() {
    slides.forEach(function (s) {
      var im = s.querySelector('img');
      if (!im || im.complete) return;
      var pre = new Image();
      if (im.sizes) pre.sizes = im.sizes;
      if (im.srcset) pre.srcset = im.srcset;
      if (im.src) pre.src = im.src;
    });
  }

  if (document.readyState === 'complete') {
    pdpWarmGallery();
  } else {
    window.addEventListener('load', pdpWarmGallery);
  }

  /* Variantes: monta a combinação a partir das opções marcadas */
  var form = document.getElementById('pdp-form');
  var select = document.getElementById('pdp-variant-select');
  var addBtn = document.getElementById('pdp-add');
  var priceBox = document.getElementById('pdp-price');

  if (form && select) {
    var radios = form.querySelectorAll('.pdp__radio');

    /* Na primeira carga a galeria não deve pular para a foto da variante:
       quem entra pelo link normal vê a foto principal do produto.
       Só respeita a variante se ela vier explicita na URL. */
    var primeiraCarga = true;
    var urlTemVariante = false;
    try {
      urlTemVariante = new URL(window.location.href).searchParams.has('variant');
    } catch (e) { /* ignora */ }

    function currentOptions() {
      var chosen = [];
      radios.forEach(function (r) {
        if (r.checked) chosen[parseInt(r.dataset.optionPosition, 10)] = r.value;
      });
      return chosen;
    }

    function syncVariant() {
      var chosen = currentOptions();
      var wanted = chosen.join(' / ');
      var match = null;

      Array.prototype.forEach.call(select.options, function (opt) {
        if (opt.textContent.trim() === wanted) match = opt;
      });

      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Indisponível'; }
        return;
      }

      select.value = match.value;

      /* Galeria acompanha a variante escolhida */
      if (match.dataset.media && (!primeiraCarga || urlTemVariante)) {
        pdpShowSlide(match.dataset.media);
      }

      var available = match.dataset.available === 'true';
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Adicionar à sacola' : 'Esgotado';
      }

      if (priceBox) {
        var html = '';
        if (match.dataset.compare) {
          html += '<span class="pdp__price-label">De</span>';
          html += '<s class="pdp__price-old">' + match.dataset.compare + '</s>';
          html += '<span class="pdp__price-label">por</span>';
        }
        html += '<span class="pdp__price-now">' + match.dataset.price + '</span>';
        priceBox.innerHTML = html;
      }

      var stickyPrice = document.getElementById('pdp-sticky-price');
      if (stickyPrice) stickyPrice.textContent = match.dataset.price;

      // Atualiza o nome da cor exibido ao lado do rótulo
      form.querySelectorAll('[data-option-current]').forEach(function (el) {
        var pos = parseInt(el.dataset.optionCurrent, 10);
        if (chosen[pos]) el.textContent = chosen[pos];
      });

      // Reflete a variante na URL, sem recarregar.
      // Não escreve na primeira carga: senao um F5 faria a galeria pular.
      if (!primeiraCarga) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.value);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* ignora */ }
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', syncVariant); });
    syncVariant();
    primeiraCarga = false;
  }

  /* Barra fixa */
  var sticky = document.getElementById('pdp-sticky');
  var stickyAdd = document.getElementById('pdp-sticky-add');
  if (sticky && addBtn) {
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sticky.classList.toggle('is-visible', !e.isIntersecting);
          sticky.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
        });
      }, { threshold: 0 });
      obs.observe(addBtn);
    }
  }

  /* ---------------------------------------------------------------
     Recomendador de tamanho

     A tabela vem do metaobjeto do produto, entao cada produto pode ter
     colunas diferentes. A secao se adapta:
       - cintura manda quando existe; sem cintura, o busto assume
       - quadril nunca decide sozinho, so faz subir de tamanho
       - busto vem em cm em algumas tabelas e em numeracao em outras
     --------------------------------------------------------------- */
  document.querySelectorAll('[data-sfinder]').forEach(function (box) {
    var rows = [];
    box.querySelectorAll('[data-sf-range]').forEach(function (el) {
      var d = el.dataset;
      rows.push({
        size: d.size,
        cMin: d.cinturaMin ? parseFloat(d.cinturaMin) : null,
        cMax: d.cinturaMax ? parseFloat(d.cinturaMax) : null,
        qMin: d.quadrilMin ? parseFloat(d.quadrilMin) : null,
        qMax: d.quadrilMax ? parseFloat(d.quadrilMax) : null,
        bMin: d.bustoMin ? parseFloat(d.bustoMin) : null,
        bMax: d.bustoMax ? parseFloat(d.bustoMax) : null,
        nota: d.nota || ''
      });
    });
    if (!rows.length) return;

    var elC = box.querySelector('[data-sf-cintura]');
    var elQ = box.querySelector('[data-sf-quadril]');
    var elB = box.querySelector('[data-sf-busto]');
    var out = box.querySelector('[data-sf-result]');
    var go = box.querySelector('[data-sf-go]');
    if (!go || !out) return;

    var temCintura = rows.some(function (r) { return r.cMin !== null; });
    var temQuadril = rows.some(function (r) { return r.qMin !== null; });
    var temBusto = rows.some(function (r) { return r.bMin !== null; });

    function show(msg) { out.hidden = false; out.innerHTML = msg; }

    function acha(valor, chaveMin, chaveMax) {
      for (var i = 0; i < rows.length; i++) {
        var mn = rows[i][chaveMin], mx = rows[i][chaveMax];
        if (mn === null) continue;
        if (valor >= mn && valor <= mx) return rows[i];
      }
      return null;
    }

    go.addEventListener('click', function () {
      var c = elC ? parseFloat(elC.value) : NaN;
      var q = elQ ? parseFloat(elQ.value) : NaN;
      var b = elB ? parseFloat(elB.value) : NaN;

      var eixo = temCintura ? 'cintura' : (temBusto ? 'busto' : null);
      if (!eixo) { show('Esta tabela não tem medidas para calcular.'); return; }

      var base = null;

      if (eixo === 'cintura') {
        if (isNaN(c)) { show('Informe a sua cintura para ver a recomendação.'); return; }
        base = acha(c, 'cMin', 'cMax');
        if (!base) {
          var comCintura = rows.filter(function (r) { return r.cMin !== null; });
          show(c < comCintura[0].cMin
            ? 'Sua cintura está abaixo da nossa menor numeração. Fale com o atendimento.'
            : 'Sua cintura está acima da nossa maior numeração. Fale com o atendimento.');
          return;
        }
      } else {
        if (isNaN(b)) { show('Informe a sua medida para ver a recomendação.'); return; }
        base = acha(b, 'bMin', 'bMax');
        if (!base) { show('Sua medida está fora da nossa tabela. Fale com o atendimento.'); return; }
      }

            /* A cintura fecha o tamanho. As pecas sao personalizadas, entao o
         quadril nunca sobe de numeracao: entra so como observacao. */
      var escolhido = base;

      var msg = 'Seu tamanho recomendado é <strong>' + escolhido.size + '</strong>.';

      if (eixo === 'cintura' && temQuadril && !isNaN(q) && escolhido.qMax !== null && q > escolhido.qMax) {
        msg += '<br><span style="font-size:.85em;">Seu quadril está acima da faixa deste tamanho. ' +
               'Fale com o atendimento para ajustarmos a peça.</span>';
      }

      /* Busto entra como conferência, nunca como decisor, quando a cintura já mandou. */
      if (eixo === 'cintura' && temBusto && !isNaN(b) && escolhido.bMax !== null && b > escolhido.bMax) {
        msg += '<br><span style="font-size:.85em;">Seu busto está acima da faixa deste tamanho. Confirme com o atendimento antes de comprar.</span>';
      }

      if (escolhido.nota) {
        msg += '<br><span style="font-size:.85em;">' + escolhido.nota + '</span>';
      }

      show(msg);
    });

    [elC, elQ, elB].forEach(function (el) {
      if (!el) return;
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter') go.click(); });
    });
  });

})();

/* =================================================================
   Mini-cart AJAX (portado do tema anterior)
   ================================================================= */
(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var overlay = document.getElementById('cd-overlay');
  var body = document.getElementById('cd-body');
  var foot = document.getElementById('cd-foot');
  var closeBtn = document.getElementById('cd-close');

  function openDrawer() {
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  window.fittOpenCart = openDrawer;

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  var openBtn = document.getElementById('cart-open');
  if (openBtn) openBtn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });

  function refresh(cart) {
    document.querySelectorAll('.cart-count, #cd-count').forEach(function (el) {
      el.textContent = cart.item_count;
      if (el.classList.contains('cart-count')) el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    fetch('/cart?view=drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nb = doc.getElementById('cd-body');
        var nf = doc.getElementById('cd-foot');
        var ns = doc.getElementById('cd-ship');
        var cs = document.getElementById('cd-ship');
        if (nb && body) body.innerHTML = nb.innerHTML;
        if (nf && foot) foot.innerHTML = nf.innerHTML;
        if (ns && cs) cs.innerHTML = ns.innerHTML;
        bindItems();
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  function changeLine(line, qty) {
    if (body) body.classList.add('cd-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (body) body.classList.remove('cd-loading'); refresh(cart); })
      .catch(function () { window.location.href = '/cart'; });
  }

  function bindItems() {
    if (!body) return;
    body.querySelectorAll('[data-cd-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(parseInt(btn.getAttribute('data-cd-qty'), 10), parseInt(btn.getAttribute('data-value'), 10));
      });
    });
  }
  bindItems();

  /* Adicionar à sacola sem recarregar */
  var pform = document.getElementById('pdp-form');
  if (pform) {
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('pdp-add');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adicionando...'; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(pform) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          if (btn) { btn.disabled = false; btn.textContent = original; }
          refresh(cart);
          openDrawer();
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
          pform.submit();
        });
    });
  }
})();

/* =================================================================
   Vídeo do card: hover no desktop, toque no mobile

   mouseenter sintetizado por toque nao libera reproducao no iOS,
   e preload="none" faz o play falhar por falta de dados. Por isso
   o mobile usa touchstart e sobe o preload antes de tocar.
   ================================================================= */
(function () {
  var cards = Array.prototype.slice.call(document.querySelectorAll('.pcard__media.has-video'));
  if (!cards.length) return;

  var semHover = window.matchMedia('(hover: none)').matches;
  var tocando = null;

  function parar(m) {
    if (!m) return;
    var v = m.querySelector('.pcard__video');
    if (v) { v.pause(); v.currentTime = 0; }
    m.classList.remove('is-playing');
    if (tocando === m) tocando = null;
  }

  function tocar(m) {
    var v = m.querySelector('.pcard__video');
    if (!v) return;
    if (tocando && tocando !== m) parar(tocando);
    if (v.preload !== 'auto') v.preload = 'auto';
    tocando = m;
    m.classList.add('is-playing');
    v.play().catch(function () { parar(m); });
  }

  if (!semHover) {
    cards.forEach(function (m) {
      m.addEventListener('mouseenter', function () { tocar(m); });
      m.addEventListener('mouseleave', function () { parar(m); });
    });
    return;
  }

  cards.forEach(function (m) {
    m.addEventListener('touchstart', function () { tocar(m); }, { passive: true });
  });

  /* Se o card sair da tela, para o video. Nunca inicia sozinho. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting && e.target === tocando) parar(e.target);
      });
    }, { threshold: 0 });
    cards.forEach(function (m) { io.observe(m); });
  }
})();

/* Filtro de preço: barra deslizante ------------------------------------- */
(function () {
  document.querySelectorAll('[data-col-price]').forEach(function (box) {
    var slider = box.querySelector('[data-col-price-slider]');
    var field = box.querySelector('[data-col-price-field]');
    var out = box.querySelector('[data-col-price-out]');
    if (!slider || !field) return;

    function fmt(v) {
      return 'R$ ' + Number(v).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    slider.addEventListener('input', function () {
      field.value = slider.value;
      if (out) out.textContent = fmt(slider.value);
    });

    slider.addEventListener('change', function () {
      var form = box.closest('form');
      if (form) form.submit();
    });
  });
})();

/* Copiar link do produto ------------------------------------------------- */
(function () {
  document.querySelectorAll('[data-share-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-share-copy');
      var done = function () {
        var old = btn.textContent;
        btn.textContent = 'Link copiado';
        setTimeout(function () { btn.textContent = old; }, 1800);
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(done).catch(function () {});
      } else {
        var t = document.createElement('textarea');
        t.value = url; document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(t);
      }
    });
  });
})();

/* Estrelas do produto levam para as avaliacoes */
(function () {
  var link = document.querySelector('[data-scroll-reviews]');
  if (!link) return;
  link.addEventListener('click', function (e) {
    var alvo = document.getElementById('avaliacoes');
    if (!alvo) return;
    e.preventDefault();
    var header = document.querySelector('.header');
    var offset = header ? header.offsetHeight + 12 : 12;
    var y = alvo.getBoundingClientRect().top + window.pageYOffset - offset;
    var reduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: y, behavior: reduzido ? 'auto' : 'smooth' });
  });
})();

/* Modal da tabela de medidas */
(function () {
  var modal = document.getElementById('guide-modal');
  if (!modal) return;
  var abre = document.querySelectorAll('[data-guide-open]');
  var fecha = modal.querySelectorAll('[data-guide-close]');

  function open() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  abre.forEach(function (b) { b.addEventListener('click', open); });
  fecha.forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });
})();
